import { render, staticRenderFns } from "./PaginateButtons.vue?vue&type=template&id=61388e72&scoped=true&"
import script from "./PaginateButtons.vue?vue&type=script&lang=ts&"
export * from "./PaginateButtons.vue?vue&type=script&lang=ts&"
import style0 from "./PaginateButtons.vue?vue&type=style&index=0&id=61388e72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61388e72",
  null
  
)

export default component.exports